import { motion, useMotionValue, useTransform } from 'framer-motion';
import { useRef } from 'react';

export default function Button({ 
  children, 
  variant = 'primary', 
  className = '', 
  onClick 
}) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const xSpring = useTransform(x, [-0.5, 0.5], [-15, 15]);
  const ySpring = useTransform(y, [-0.5, 0.5], [-15, 15]);

  const rectRef = useRef(null);
  const handleMouseEnter = ({ currentTarget }) => {
    rectRef.current = currentTarget.getBoundingClientRect();
  };

  const handleMouseMove = (e) => {
    if (!rectRef.current) return;
    const rect = rectRef.current;
    const width = rect.width;
    const height = rect.height;
    
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    
    // Normalize -0.5 to 0.5
    const xPct = mouseX / width - 0.5;
    const yPct = mouseY / height - 0.5;
    
    x.set(xPct);
    y.set(yPct);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
    rectRef.current = null;
  };

  const isPrimary = variant === 'primary';

  const baseClasses = "relative overflow-hidden font-mono uppercase tracking-widest text-sm transition-all duration-300 border-2 rounded-none inline-flex items-center justify-center";
  const primaryClasses = "bg-[#CCFF00] text-black border-[#CCFF00] hover:bg-white hover:border-white px-8 py-4";
  const outlineClasses = "bg-transparent border-white text-white hover:bg-white hover:text-black hover:border-white px-8 py-4";

  return (
    <motion.button
      ref={ref}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={{ x: xSpring.get(), y: ySpring.get() }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
      whileHover={{ scale: isPrimary ? 1.05 : 1.02 }}
      className={`${baseClasses} ${isPrimary ? primaryClasses : outlineClasses} ${className}`}
    >
      <span className="relative z-10 flex items-center justify-center gap-2">
        {children}
      </span>
    </motion.button>
  );
}
